/* eslint-disable camelcase */
import { OpeningsService } from 'api-clients/monolith';

import { useApiServiceMutation } from './useApiServiceMutation';

export interface CreateOpeningApprovalRequest {
  hiring_goals_attributes: Array<{
    goal: number;
    hire_by?: string | null;
    start_date: string;
    form_index?: number | null;
    req_id?: string | null;
    owner_external_id?: string | null;
  }>;
  request_reason: string;
}

export function useCreateOpeningApproval() {
  const { mutation, result, reset } = useApiServiceMutation(
    (id: string, requestBody?: CreateOpeningApprovalRequest) =>
      OpeningsService.postInternalApiOpeningsApprovals(
        id,
        requestBody,
      ) as import('api-clients/monolith').CancelablePromise<unknown>,
  );
  return { createApproval: mutation, result, reset };
}
